import { useEffect, useState } from 'react';
import { Card, Row, Col, Badge, message } from 'antd';
import CustomText from '../../../CustomText';
import API from "../../../../services/API";
import { CopyOutlined } from '@ant-design/icons';
import LoaderComponent from '../../../Loader';
import {
  convertCentsIntoDollar,
  formatDate,
} from '../../../../helpers/genericHelper';


export default function PaymentLinkPanel({ userId }) {

  const [paymentLinks, setPaymentLinks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  const copyPaymentLink = (paymentLink) => {
    if (paymentLink && navigator?.clipboard) {
      navigator.clipboard.writeText(paymentLink);
      message.success('Copied link to clipboard!')
    }
  }

  useEffect(() => {
    const getLinks = async () => {
      const links = await API.getPaymentLinkList({ userId });
      setPaymentLinks(links);
      setIsLoading(false);
    }

    getLinks();
  }, [userId]);

  return (
    <>
      { isLoading ? <LoaderComponent /> :
          paymentLinks.map((link) => {
            return (
              <Card
                bordered={false}
                hoverable={true}
                className="criclebox tablespace mb-16"
              >
                <Row
                  className="save-build-box-container"
                  gutter={[30, 30]}
                  justify="space-between"
                >
                  <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                    <h4>Link</h4>
                    <CustomText
                      dataSet={link}
                      property1={'paymentLink'}
                    /> <CopyOutlined onClick={() => copyPaymentLink(link?.paymentLink)} style={{ cursor: 'pointer'}}/>
                  </Col>
                  <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                    <h4>Amount</h4>
                    <CustomText
                      dataSet={link}
                      property1={'amountInCents'}
                      formatter={(val) => convertCentsIntoDollar(val)}
                    />
                  </Col>
                  <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                    <h4>Status</h4>
                    <Badge status={link?.status === "expired" ? "error" : (link?.status === "active" ? "processing" : (link?.status === "paid" ? "success" : ("default")))} />
                    &nbsp;
                    <CustomText
                      dataSet={link}
                      property1={'status'}
                      formatter={(val) => val.toUpperCase()}
                    />
                  </Col>
                  <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                    <h4>Created</h4>
                    <CustomText
                      dataSet={link}
                      property1={'createTs'}
                      formatter={(val) => formatDate(val, true)}
                    />
                  </Col>
                </Row>
              </Card>
            )
          })
      }
    </>
  );
}